import { render } from "./ManualNav.vue?vue&type=template&id=da3f23bc&scoped=true"
import script from "./ManualNav.vue?vue&type=script&lang=js"
export * from "./ManualNav.vue?vue&type=script&lang=js"

import "./ManualNav.vue?vue&type=style&index=0&id=da3f23bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3f23bc"]])

export default __exports__